import styled from "styled-components";

export const FullRow = styled.div`
  grid-column: 1 / -1;
`;
